import Esqueleto from "../../../components/Esqueleto";
import { useState } from "react";
import Relatorio from "../../../../models/Relatorio";
import { ESTADOS_UF } from "../../../../utils/localidades";
import BarrasHorizontais from "../BarrasHorizontais";
import FiltrosLocalidade from "../FiltrosLocalidade";
import TabelaAdmin from "../../../components/TabelaAdmin";
import { COR_PAPEL, Filtros, Secao } from "../painel";
import { numero, useRelatorio } from "../useRelatorio";

const LIMITE = 50;
const LIMITE_NO_GRAFICO = 15;
const INICIAL = { regiao: "", estado: "", agrupar: "estado" };
const ROTULO_AGRUPAR = { regiao: "região", estado: "estado", cidade: "cidade" };

// "Usuários por localidade": usuários ATIVOS por região, estado ou cidade, com a
// divisão por papel (comuns, profissionais, administradores).
export default function UsuariosPorLocalidade() {
  const [filtros, setFiltros] = useState(INICIAL);
  const alterar = (parte) => setFiltros((atual) => ({ ...atual, ...parte }));
  const agrupar = filtros.agrupar === "cidade" && !filtros.estado ? "estado" : filtros.agrupar;

  const { dados, erro, carregando } = useRelatorio(Relatorio.usuariosPorLocalidade, {
    agrupar, regiao: filtros.regiao, estado: filtros.estado, limite: LIMITE,
  });

  const itens = dados?.itens || [];
  const noGrafico = itens.slice(0, agrupar === "regiao" ? itens.length : LIMITE_NO_GRAFICO);
  const nomeEstado = ESTADOS_UF.find((e) => e.uf === filtros.estado)?.nome;
  const filtrado = filtros.regiao || filtros.estado || filtros.agrupar !== INICIAL.agrupar;

  return (
    <Secao aria-labelledby="titulo-usuarios-localidade">
      <div>
        <h3 id="titulo-usuarios-localidade">Usuários por localidade</h3>
        <p className="sub">
          Contas ativas por {ROTULO_AGRUPAR[agrupar]}{agrupar === "cidade" && nomeEstado ? ` — ${nomeEstado}` : ""}, separadas por tipo de perfil.
        </p>
      </div>

      <Filtros>
        <FiltrosLocalidade valores={{ ...filtros, agrupar }} onChange={alterar} />
        {filtrado && <button type="button" className="limpar" onClick={() => setFiltros(INICIAL)}>Limpar filtros</button>}
        {!filtros.estado && <span className="dica">Escolha um estado para ver os usuários por cidade.</span>}
      </Filtros>

      {carregando && <Esqueleto variante="barras" quantidade={8} rotulo="Carregando relatório" />}
      {erro && <div className="erro" role="alert">{erro}</div>}

      {!carregando && !erro && dados && (
        <>
          <div className="totais">
            <span><strong>{numero(dados.total)}</strong> usuários ativos</span>
          </div>

          {dados.total === 0
            ? <div className="vazio">Nenhum usuário encontrado com esses filtros.</div>
            : (
              <>
                <BarrasHorizontais
                  rotulos={noGrafico.map((i) => i.label)}
                  series={[
                    { name: "Comuns", color: COR_PAPEL.Comum, data: noGrafico.map((i) => i.comuns) },
                    { name: "Profissionais", color: COR_PAPEL.Profissional, data: noGrafico.map((i) => i.profissionais) },
                    { name: "Administradores", color: COR_PAPEL.Administrador, data: noGrafico.map((i) => i.administradores) },
                  ]}
                  tooltip={(i) => `<strong>${noGrafico[i].label}</strong><br/>${numero(noGrafico[i].usuarios)} usuários<br/>${numero(noGrafico[i].comuns)} comuns · ${numero(noGrafico[i].profissionais)} profissionais · ${numero(noGrafico[i].administradores)} administradores`}
                  descricao={`Usuários ativos por ${ROTULO_AGRUPAR[agrupar]}, divididos por tipo de perfil. Os valores estão na tabela abaixo.`}
                />

                <TabelaAdmin
                  rotulo={`Usuários ativos por ${ROTULO_AGRUPAR[agrupar]}`}
                  linhas={itens}
                  chave={(i) => i.chave}
                  larguraMinima={640}
                  paginar={25} itens="localidades"
                  colunas={[
                    { id: "local", rotulo: agrupar === "regiao" ? "Região" : agrupar === "estado" ? "Estado" : "Cidade", largura: "minmax(180px, 3fr)",
                      celula: (i) => (
                        <span className="rotulo-linha">
                          {i.label}
                          {agrupar === "estado" && i.regiao && i.regiao !== "Não informado" && <small>{i.regiao}</small>}
                          {agrupar === "cidade" && i.uf && <small>{i.uf}</small>}
                        </span>
                      ) },
                    { id: "usuarios", rotulo: "Usuários", largura: "minmax(90px, 1fr)", direita: true, celula: (i) => numero(i.usuarios) },
                    { id: "comuns", rotulo: "Comuns", largura: "minmax(90px, 1fr)", direita: true, celula: (i) => numero(i.comuns) },
                    { id: "pro", rotulo: "Profissionais", largura: "minmax(110px, 1fr)", direita: true, celula: (i) => numero(i.profissionais) },
                    { id: "adm", rotulo: "Administradores", largura: "minmax(130px, 1fr)", direita: true, celula: (i) => numero(i.administradores) },
                  ]}
                />
              </>
            )}
        </>
      )}
    </Secao>
  );
}
